import { c as _c } from "react/compiler-runtime";
import { STORES_API } from 'modules/stores/api/stores-api';
import { StoreListApiInterface } from 'modules/stores/types/stores-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
export const useStores = () => {
  const $ = _c(6);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== user) {
    t1 = () => user && `${STORES_API}?page=1&itemsPerPage=50`;
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: stores,
    mutate
  } = useSWR(t1, fetcher);
  let t2;
  if ($[3] !== mutate || $[4] !== stores) {
    t2 = {
      stores,
      mutate
    };
    $[3] = mutate;
    $[4] = stores;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};